import classes from "./MainHeader.module.css";

const MainHeader = (props) => {
  return (
    <div className={classes.main_header}>
      <img
        className={classes.main_icon}
        src={"/assets/decorations/decor_icon_2_thick.svg"}
        alt="new"
      />
      <div className={classes.main_title}>{props.title}</div>
  
      <img
        className={classes.main_icon}
        src={"/assets/decorations/decor_icon_2_thick.svg"}
        alt="new"
      />
    </div>
  );
};

export default MainHeader;
